import React, { useMemo } from 'react';
import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import GenericTable from '../../../../components/tables/GenericTable';
import { getOccurrenceStatusDisplayLabel } from '../../utils/therapyOccurrencePresentation';
import StatusFlag from '../../../../components/elements/StatusFlag';
import {
  getOccurrenceStatusTone,
} from '../../../../shared/utils/statusTones';

const infoRowStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 24,
  marginBottom: 16,
};

const ReservedTherapiesModal = ({ isOpen, onClose, patient }) => {
  const occurrences = useMemo(
    () =>
      Array.isArray(patient?.reservedOccurrences)
        ? patient.reservedOccurrences
        : [],
    [patient?.reservedOccurrences]
  );

  const patientName =
    [patient?.firstName, patient?.lastName].filter(Boolean).join(' ') ||
    'Pacijent';

  const columns = useMemo(
    () => [
      {
        key: 'therapyName',
        label: 'Terapija',
        render: (value, row) => {
          const medications = Array.isArray(row?.medications)
            ? row.medications.join(', ')
            : '';

          return value || medications || '-';
        },
      },
      {
        key: 'medications',
        label: 'Lekovi',
        render: (value) =>
          Array.isArray(value) && value.length ? value.join(', ') : '-',
      },
      {
        key: 'sequenceNumber',
        label: 'Mesec',
        render: (value) => value || '-',
      },
      {
        key: 'scheduledDate',
        label: 'Datum',
        render: (value) => (value ? dayjs(value).format('DD.MM.YYYY') : '-'),
      },
      {
        key: 'status',
        label: 'Status',
        render: (_, row) => (
          <StatusFlag tone={getOccurrenceStatusTone(row?.status)}>
            {getOccurrenceStatusDisplayLabel(row)}
          </StatusFlag>
        ),
      },
      {
        key: 'note',
        label: 'Napomena',
        render: (value) => value || '-',
      },
    ],
    []
  );

  return (
    <Modal
      width={900}
      title={`Rezervisane terapije - ${patientName}`}
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Zatvori
        </Button>,
      ]}
    >
      <div style={infoRowStyle}>
        <div>
          <strong>LBO:</strong> {patient?.userLbo || '-'}
        </div>
        <div>
          <strong>BZK:</strong> {patient?.healthBookletNumber || '-'}
        </div>
        <div>
          <strong>Rezervisanih terapija:</strong>{' '}
          {patient?.reservedCount ?? occurrences.length}
        </div>
      </div>
      <GenericTable
        data={occurrences}
        columns={columns}
        emptyState={{
          icon: '/assets/icons/no-users.svg',
          title: 'Nema rezervisanih terapija',
        }}
      />
    </Modal>
  );
};

ReservedTherapiesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  patient: PropTypes.object,
};

export default ReservedTherapiesModal;
